import { useState } from 'react';
import { DOC_TYPES, fmtType } from './segmentTypes';

// One small inline form for the three typed corrections: rename, change type,
// move the start page. Non-modal; Enter saves, Escape cancels.
export default function SegInlineEdit({ kind, value = '', pageCount = 0, onSave, onCancel, busy = false }) {
  const [v, setV] = useState(kind === 'move' ? String(value || '') : (value || ''));
  const submit = (e) => {
    e.preventDefault();
    const t = String(v).trim();
    if (kind === 'move') {
      const to = parseInt(t, 10);
      if (!Number.isFinite(to) || to < 2 || to > pageCount) return;
      onSave({ to_page: to });
    } else {
      if (!t) return;
      onSave({ value: t });
    }
  };
  return (
    <form className="seg-inline-edit" data-testid={`seg-edit-${kind}`} onSubmit={submit} onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => { if (e.key === 'Escape') { e.preventDefault(); onCancel?.(); } }}>
      {kind === 'move' && (<>
        <label>Starts on page</label>
        <input type="number" min={2} max={pageCount} value={v} autoFocus onChange={(e) => setV(e.target.value)} />
      </>)}
      {kind === 'rename' && (<>
        <label>Title</label>
        <input type="text" value={v} autoFocus maxLength={200} placeholder="e.g. Witness statement – J. Smith" onChange={(e) => setV(e.target.value)} />
      </>)}
      {kind === 'retype' && (<>
        <label>Type</label>
        <input type="text" list="seg-doc-types" value={v} autoFocus maxLength={80} onChange={(e) => setV(e.target.value)} />
        <datalist id="seg-doc-types">{DOC_TYPES.map((t) => <option key={t} value={t}>{fmtType(t)}</option>)}</datalist>
      </>)}
      <button type="submit" className="btn btn-sm btn-primary-ghost" disabled={busy}>Save</button>
      <button type="button" className="btn btn-sm btn-ghost" onClick={onCancel}>Cancel</button>
    </form>
  );
}
